import { Navbar, NavbarBrand, Button } from "reactstrap";
import EALogo from "./EALogo";
import { CustomError } from "../model/internal/customError";

interface ErrorHandlerProps {
  customError: CustomError;
  resetErrorBoundary: () => void;
}

const ErrorHandler = ({ customError, resetErrorBoundary }: ErrorHandlerProps) => {
  const { REACT_APP_THEME } = process.env;

  return (
    <>
      <div role="alert" className="text-center">
        <Navbar
          color={REACT_APP_THEME}
          className="navbar-dark bd-navbar"
          expand="lg"
          fixed="top"
          id="ea_navbar"
        >
          <NavbarBrand tag="div" className="d-flex justify-content-start bg-visnet">
            <EALogo
              theme={REACT_APP_THEME}
              displayName={""}
              color="#fff"
              logoColor="#fff"
              logoBgColor="#fab274"
            />
          </NavbarBrand>
        </Navbar>

        <h1 className="pt-3">Error</h1>
        <pre className="text-danger" style={{ fontSize: "1rem" }}>
          {customError.errorUtc ?? ""}
          <br />
          Id: {customError.errorId ?? ""}
          <br />
          {customError.message}
        </pre>
        <Button color="btn btn-primary btn-sm" onClick={resetErrorBoundary}>
          Reset
        </Button>
      </div>
    </>
  );
};

export default ErrorHandler;
